<template>
  <footer class="page-footer text_center_small">
    <div class="container">
      <div class="row row-md-middle row-md-reverse">
        <div class="col-md-1"></div>
        <div class="col-md-3">
          <ul class="inline-list">
            <li><a href="https://www.facebook.com/elizabethsskincare" class="icon icon-xs fa-facebook"></a></li>
            <li><a href="#" class="icon icon-xs fa-pinterest"></a></li>
            <li><a href="#" class="icon icon-xs fa-twitter"></a></li>
            <li><a href="#" class="icon icon-xs fa-google-plus"></a></li>
            <li><a href="#" class="icon icon-xs fa-instagram"></a></li>
          </ul>
        </div>
        <div class="col-md-4 text-center">
          <!-- RD Navbar Brand -->
          <a href="index.html" class="brand">
            <div class="brand-logo"></div>
            <div class="brand-name">
              <span class="text-uppercase">ELIZABETH</span>
            </div>
            <div class="brand-slogan">European Skin Care</div>
          </a>
          <!-- END RD Navbar Brand -->
        </div>
        <div class="col-md-3 col-md-preffix-1 text-center text-md-left">
          <p class="copyright">
            Elizabeth © <span id="copyright-year"></span><br>
            <!--All Rights Reserved. <a href='index-5.html'>Privacy Policy</a>
            SiSCOTEK -->Designed and Maintained by <a rel="nofollow" href="http://www.siscotek.com/" target="_blank">SiSCOTEK</a>
          </p>
        </div>
      </div>
    </div>
  </footer>
</template>


<script>
  export default {
    name: 'Footer'
  }
</script>

<style scoped>
  
</style>